window.Lemonade = window.Lemonade || {};

var isMobile = {
  Android: function() {
      return navigator.userAgent.match(/Android/i);
  },
  BlackBerry: function() {
      return navigator.userAgent.match(/BlackBerry/i);
  },
  iOS: function() {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  Opera: function() {
      return navigator.userAgent.match(/Opera Mini/i);
  },
  Windows: function() {
      return navigator.userAgent.match(/IEMobile/i);
  },
  any: function() {
      return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
  }
};

Shopify.handleize = function (str) {
	return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
};

// Global selectors and values
Lemonade.cacheSelectors = function(){

	Lemonade.cache = {

		// General
		$win: $(window),
		$body: $('html,body'),
		$back_to_top: $('#BackToTop'),

		// Header & Nav
		$header: $('#AppHeader'),
		$app_promo: $('#AppPromo'),
		header_specs: null,

		// Cart
		$cartCount: $('.CartCount'),
		$cart_flyout: $('#CartFlyout')

	};

};

Lemonade.galleryLocator = function(){
  const nearestGallery = document.getElementById('nearestGallery');
  const locationLink = document.querySelector('#getNearestGallery a');

  // Get User's Coordinate from their Browser
  window.onload = function() {
    // HTML5/W3C Geolocation
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(UserLocation);
    } else {
      nearestGallery.innerHTML = 'Find Gallery';
    }
  };

  // Callback function for asynchronous call to HTML5 geolocation
  function UserLocation(position) {
    NearestCity(position.coords.latitude, position.coords.longitude);
    // console.log("Lat " + position.coords.latitude);
    // console.log("Lon " + position.coords.longitude);
  }

  // Convert Degress to Radians
  function Deg2Rad(deg) {
    return (deg * Math.PI) / 180;
  }

  function PythagorasEquirectangular(lat1, lon1, lat2, lon2) {
    lat1 = Deg2Rad(lat1);
    lat2 = Deg2Rad(lat2);
    lon1 = Deg2Rad(lon1);
    lon2 = Deg2Rad(lon2);
    var R = 6371; // km
    var x = (lon2 - lon1) * Math.cos((lat1 + lat2) / 2);
    var y = lat2 - lat1;
    var d = Math.sqrt(x * x + y * y) * R;
    return d;
  }

  var lat = 20; // user's latitude
  var lon = 40; // user's longitude

  var cities = [
    ["New York", 40.726090,-74.000270, "/pages/new-york-new-york"],
    ["Schaumburg", 42.046260, -88.036460, "/pages/schaumburg-illinois"],
    ["San Francisco", 37.787400, -122.409390, "/pages/san-francisco-california"],
    ["New Orleans", 29.956350, -90.066580, "/pages/new-orleans-louisiana"],
    ["Las Vegas", 36.119020, -115.176310, "/pages/las-vegas-nevada"],
    ["Lahaina", 20.875240, -156.679830, "/pages/lahaina-hawaii"],
    ["La Jolla", 32.8481074, -117.2732671, "/pages/la-jolla-california"],
    ["Dallas", 32.9304452, -96.8195079, "/pages/dallas-texas"],
    ["Costa Mesa", 33.6924264, -117.8928865, "/pages/costa-mesa-california"]
  ];

  function NearestCity(latitude, longitude) {
    var minDif = 99999;
    var closest;

    for (index = 0; index < cities.length; ++index) {
      var dif = PythagorasEquirectangular(
        latitude,
        longitude,
        cities[index][1],
        cities[index][2]
      );
      if (dif < minDif) {
        closest = index;
        minDif = dif;
      }
    }

    // echo the nearest city
    console.log(cities[closest]);

    locationLink.setAttribute('href', cities[closest][3])
    nearestGallery.innerHTML = cities[closest][0];

  }  
}

// Kick off functions
Lemonade.init = function(){

  var bodyClasses = document.body.classList;

	Lemonade.cacheSelectors();
	Lemonade.fastClick();
	Lemonade.lazyLoad();
	Lemonade.animateIn();
	Lemonade.globalHeader();
	Lemonade.billboards();
	Lemonade.accordion();
  
  Lemonade.slick();
  Lemonade.matchHeight();
	Lemonade.autoResponsiveElements();
	Lemonade.cache.$win.load(function(){
    Lemonade.fitVids();
    Lemonade.masonry();
	});
	Lemonade.productMedia();
	//Lemonade.sticky();
	Lemonade.backToTop();
	Lemonade.popupModules();
	//Lemonade.productHover();
	Lemonade.mailchimp();
	Lemonade.productZoom();
	Lemonade.customProductSelects();
	Lemonade.customSelects();
	//Lemonade.productQuantity();
	Lemonade.initCartFlyout();
	Lemonade.gdpr();
  Lemonade.collectionAjaxLoad();

  if (bodyClasses.contains('template-product')){
    Lemonade.viewInRoomApp.init();
  }

  Lemonade.artistViewToggleInit();
  Lemonade.artistPage();
  Lemonade.mobileFilterSort();
  Lemonade.artworkInquiry();
  Lemonade.blogFilters();
  Lemonade.countDown();
  Lemonade.galleryLocator();

  if (bodyClasses.contains('gallery')) {
    Lemonade.galleryPage();
  }
};

// Fastclick library dependancy https://github.com/ftlabs/fastclick
// Remove mobile click delay
Lemonade.fastClick = function(){
	FastClick.attach(document.body);
};

// Lazy Load library dependancy http://jquery.eisbehr.de/lazy
// Dynamically load images
Lemonade.lazyLoad = function(){
	$('.Lazy').Lazy({
		effect: 'fadeIn',
		visibilityOnly: true,
		onError: function(element){
			console.log('error loading ' + element.data('src'));
		},
		afterLoad: function(element) {
			Lemonade.matchHeight();
			Lemonade.productZoom();
		}
	});
};

// Return window scrollTop
Lemonade.windowScrollTop = function(){
	return $(window).scrollTop();
};

// Body no scroll
Lemonade.scrollYes = function(){
	Lemonade.cache.$body.removeClass('NoScroll');
};

// Body yes scroll
Lemonade.scrollNo = function(){
	Lemonade.cache.$body.addClass('NoScroll');
};

// Library dependancy https://github.com/liabru/jquery-match-height
// jQuery Match Height
Lemonade.matchHeight = function(){
	var $product_item = $('.GridItem');
	$('.MH').matchHeight();
	$product_item.find('.ItemImage').matchHeight();
	$product_item.find('.item-details').matchHeight();
};

// Library dependancy https://github.com/protonet/jquery.inview
// Animate Elements when inview
Lemonade.animateIn = function(){
	$('.AnimateIn').on('inview', function(event, isInView) {
	  if (isInView) {
	    $(this).addClass('InView');
	  } else {
	    $(this).removeClass('InView');
	  }
	});
};

// Return a bunch of header specs
Lemonade.headerCalculations = function(){

  var is_transparent_header = false;

  if(Lemonade.cache.$body.hasClass('template-index')){
	  is_transparent_header = true;
  }

  
	  
		  total_offset = Lemonade.cache.$header.height() + Lemonade.cache.$app_promo.outerHeight();
	  
	

  Lemonade.cache.header_specs = {
	  header_height: Lemonade.cache.$header.height(),
	  bar_height: Lemonade.cache.$app_promo.outerHeight(),
	  header_plus_bar: Lemonade.cache.$header.height() + Lemonade.cache.$app_promo.outerHeight(),
	  total_offset: total_offset
  };

  return Lemonade.cache.header_specs;

};

// Global Header + Navigation
Lemonade.globalHeader = function(){

	// init settings and selectors
  var $main_content = $('.MainContent'),
      $mega_trigger = $('.AppNavUl > li > a'),
      $mega_menu_container = $('#MegaMenuContainer'),
	    $mega_menu = $('.MegaMenu'),
	    $nav_mobile = $('#AppNavMobile'),
	    $tp = $('.TransitionPoint'),
	    speed = 100,
	    len = $tp.length,
	    $me_menu = null,
	    openTimer,
	    closeTimer,
	    intentTimer,
	    win_pos,
	    tp_pos,
	    state,
      winState;

	//-- FUNCTIONS ---//

	// Check state of window width (wide vs narrow screen)
	var winState = function() {
		win_width = Lemonade.cache.$win.width();
		if(win_width > 1023){
			if (state != 'max') {
				state = 'max';
				changedstate(state);
			};
		} else if (win_width > 767 && win_width <= 1023){
			if (state != 'desktop') {
				state = 'desktop';
				changedstate(state);
			};
		} else {
			if (state != 'mobile') {
				state = 'mobile';
				changedstate(state);
			};
		} 
	}

  // If/When window crosses the wide/narrow threshold you can do some stuff here
	function changedstate(mystate){
		if(mystate == 'max'){
			Lemonade.cache.$body
				.removeClass('NarrowScreen WideScreen')
				.addClass('MaxScreen');
			// Close mobile menu if going to wide screen
      closeMobileMenu();
      $('#ARInstr').fadeOut();
      if($('#ARSlick').length > 0 && $('#ARSlick').hasClass('slick-initialized')){
        $('#ARSlick').slick('unslick');
        $('#ar-instr-inner').find('.SliderWrap').removeClass('Show');
      }
		} else if(mystate == 'desktop'){
			// Do wide screen stuff here
			Lemonade.cache.$body
			  .removeClass('NarrowScreen MaxScreen')
        .addClass('WideScreen');
      $('#ARInstr').fadeOut();
      if($('#ARSlick').length > 0 && $('#ARSlick').hasClass('slick-initialized')){
        $('#ARSlick').slick('unslick');
        $('#ar-instr-inner').find('.SliderWrap').removeClass('Show');
      }
	  } else {
		  // Do narrow screen stuff here
		  Lemonade.cache.$body
		    .removeClass('WideScreen MaxScreen')
			  .addClass('NarrowScreen');
	  }
	}

	// Loops through a standard Shopify menu/submenu structure and pulls the sub menus out of their parent-child DOM relationship and
	// appends them to a designated wrapper div just outside the #AppHeader. This allows the use nested menu building in the admin while
	// providing some frontend flexibility
	function buildMegaMenus(){
		// target the class applied to any parent menu item with a submenu associated with it
		$('.HasDropdown').each(function(i,el){
			// reference to each one during loop iteration
			$me = $(el);
			// grab the submenu of each
			$me_sub = $me.next('.SiteNavDropdown');
			// append that sub menu to the placeholder div already created in the DOM
			$mega_menu_container.append($me_sub);
    });

		$('.HasDropdownMobile').each(function(i,el){
			// reference to each one during loop iteration
			$me = $(el);
			// grab the submenu of each
			$me_sub = $me.next('.SiteNavDropdownMobile');
			// append that sub menu to the placeholder div already created in the DOM
			$('#AppNavMobile').append($me_sub);
		});


  }
   
	// Close the submenu and reset everything (see headerResets function for more detail)
	function closeMenu($me){
    // remove the active class from the trigger
    $me.removeClass('Activated').attr('aria-expanded', 'false');

    // fadeOut the active menu
    $mega_menu.fadeOut(function(){
      // after menu has faded out call the headerResets() for more resetting
      headerResets();
    });
	}

	// Open the submenu
	function openMenu($me){

    var openIt;
    
			// create a timeout to offset the timing of sub menu opening
	    openTimer = window.setTimeout(function() {
        timeoutId = null;
        // Grab the data attribute value off of the currently selected trigger.
        // This value matches the ID of the correlating submenu
        this_menu = $me.data('mega-menu');
        // Create selector from this attribute value
				$me_menu = $('#'+this_menu);
				// Get sibling mega menus
				$me_menu_siblings = $me_menu.siblings('.MegaMenu');
				// Get the height of the submenu to be opened
				me_menu_height = $me_menu.innerHeight();
				// Activate the current trigger and deactivate the others
        //$me.stop().addClass('Activated').siblings().removeClass('Activated');
        $me.stop().addClass('Activated').attr('aria-expanded', 'true').siblings().removeClass('Activated').attr('aria-expanded', 'false');
				// Stop closing of submenus
				clearTimeout(closeTimer);
				// Add open class to AppHeader
				Lemonade.cache.$header.addClass('MenuOpen');
				openIt = function(){
					// this function does some calculations to open the submenus appropriately (see function for more detail)
					headerOffsets(me_menu_height, false);
					$mega_menu_container.addClass('Open');
					// Fade in the current mega menu with a little delay
					setTimeout(function(){
            $me_menu.fadeIn();
            setTimeout(function(){
              $me_menu.focus();
            }, 300);
          }, 300);
				};
				// fadeOut any open Mega menus in preperation for the current one to be opened else just open it
				if($me_menu_siblings.length > 0){
					$me_menu_siblings.fadeOut(function(){
						openIt();
					});
				} else {
					openIt();
				}
			}, speed);

	}

	// Open/Close submenu depending
  function toggleMenu(new_trigger, old_trigger){
    openMenu(new_trigger);
    closeMenu(old_trigger);
  }

  jQuery.fn.clickToggle = function(a,b) {
    var ab = [b,a];
    return this.on("click", function(){ ab[this._tog^=1].call(this); });
  };

  // Internal Mobile Mega Menu Panels
  $('.HasDropdownMobile').on('click keyup', function(e){
    e.preventDefault();
    if(e.type == 'click' || e.which == 13){
      var $me = $(this),
          me_mega_data = $me.attr('data-mega-menu'),
          $me_mega = $('#'+me_mega_data);

      if(!$me.hasClass('Open')){
        $me.addClass('Open').attr('aria-expanded', 'true');
        $me_mega.addClass('ShowMenu');
        setTimeout(function(){
          $me_mega.focus();
        }, 300);
      } else {
        $me.removeClass('Open').attr('aria-expanded', 'false');
        $me_mega.removeClass('ShowMenu');
        setTimeout(function(){
          $me_mega.blur();
        }, 300);        
      }
    }
  });

  $('.MegaMenuBack').on('click keyup', function(e){
    if(e.type == 'click' || e.which == 13){
      var $me = $(this),
          $me_dropdown = $me.closest('.SiteNavDropdownMobile'),
          me_back = $me_dropdown.attr('id');
      $me_dropdown.removeClass('ShowMenu');
      $('[data-mega-menu="'+me_back+'"]').removeClass('Open').attr('aria-expanded', 'false');
    }
  });

  // This function handles all the logic for determing offset positioning of elements affected by
  // sticky header, global promo bar and scrolled state of site header
  // takes 3 arguments: height of the sub menu being opened and true/false if first init on window.load.
	function headerOffsets(heighty, init){

		var h,t,p;

		// get the current header specs/dimensions
		Lemonade.headerCalculations();

		// Push the site header down from under the fixed promo bar
		Lemonade.cache.$header.css('top', Lemonade.cache.header_specs.bar_height);

		// Push the page content down from under the fixed header/fixed header + fixed promo bar
		$main_content.css('padding-top', Lemonade.cache.header_specs.total_offset);

		// If function is being called from within openMenu function set styles accordingly
		// These are ignored in the first init of headerOffsets()
		if(!init){
			// If scrolled past the header should have a color filled bg. In this case the mega menus can be pushed down to the bottom of the header
			if(Lemonade.cache.$header.hasClass('ScrolledPast')){
				// set the height of the current mega menu + a little extra cushioning. Flex css will handle the centering of the elements in the menu.
				// offset the mega menu to be below the header
				// Since mega menu starts at the bottom of site header no paddingTop required
				h = heighty;
				t = Lemonade.cache.header_specs.header_height;
				p = 0;
			} else {
				// set the height of the current mega menu + a little extra cushioning. Flex css will handle the centering of the elements in the menu.
				// In this case the site header should still be transparent. Mega Menus are never transparent so instead of animating the header bg color simultaneously
				// with the animating of the mega menu (this would look like crap), we will simply set the mega menu behind the site header with enough paddingTop to push
				// menu elements down below header elements. This allows for one seemless animation to bring both the site header and mega menu onto a white bg.
				h = heighty;
				t = Lemonade.cache.header_specs.header_height;
				p = 0;
			}

			
				t = t + Lemonade.cache.header_specs.bar_height;
			

			$mega_menu_container.css({
				height: h,
				top: t,
				paddingTop: p
			});

		}
	}

	// Reset Mega Menus height and paddingTop to 0
	function headerResets(){
		$mega_menu_container.css({
			height: 0,
			paddingTop: 0
		}).removeClass('Open');
		// remove the open class applied to the AppHeader
		setTimeout(function(){
			Lemonade.cache.$header.removeClass('MenuOpen');
		}, 400);
	}

	// Header Utilities (toggle items visible/hidden)
	function headerUtilities(){
		var $utility_trigger = $('.UtilTrigger');

		$utility_trigger.on('click keyup', function(e){
      if(e.type == 'click' || e.which == 13){
        var $me = $(this),
            me_util = $me.data('utility');

        $me.siblings().removeClass('Active');
        $('.UtilItem').removeClass('Show');

        if($me.hasClass('Active')){
          $me.removeClass('Active').attr('aria-expanded', 'false');
          $('#'+me_util).removeClass('Show');
          if(me_util == 'AppSearch'){
            Lemonade.scrollYes();
          }
        } else {
          $me.addClass('Active').attr('aria-expanded', 'true');
          $('#'+me_util).addClass('Show');
          if(me_util == 'AppSearch'){
            setTimeout(function(){
              $('#AppSearch').focus();
            }, 300);
            Lemonade.scrollNo();
          }
        }
      }
    });

    $('.search-close').on('click keyup', function(e){
      if(e.type == 'click' || e.which == 13){
        $('.UtilTrigger[data-utility="AppSearch"]').click();
      }
    });
	}

	// Header transition on scroll
	var transitionPoint = function(){

		// get the current header specs/dimensions
		Lemonade.headerCalculations();
		//headerCalcs();

		// get window scroll position
		win_pos = Lemonade.cache.$win.scrollTop();

		// if transition point trigger exists in the DOM continue
		if(len > 0){
			// get the offset of the transition point trigger
		  tp_pos = $tp.offset().top;
		  // if scrolled beyond transition point do stuff
			if(win_pos > tp_pos){
				if(!Lemonade.cache.$header.hasClass('ScrolledPast')){
					Lemonade.cache.$header.addClass('ScrolledPast');
					$mega_menu_container.css({
						top: Lemonade.cache.header_specs.header_plus_bar
					});
				}
			} else {
				if(Lemonade.cache.$header.hasClass('ScrolledPast')){
					Lemonade.cache.$header.removeClass('ScrolledPast');
					$mega_menu_container.css({
						top: Lemonade.cache.header_specs.bar_height
					});
				}
			}
		}
	};

	// Close the mobile menu
	var closeMobileMenu = function(){
		if($nav_mobile.hasClass('ShowMenu')){
			$nav_mobile.removeClass('ShowMenu');
			Lemonade.cache.$body.removeClass('NoScroll');
		}
  };
  
  //-- EVENTS AND FUNCTION CALLS ---//
  // $mega_trigger.on('mouseenter mouseleave focus', function(e){
	// 		$me = $(this);
	// 		var old_trigger = Lemonade.cache.old_trigger;
  //     var new_trigger = Lemonade.cache.old_trigger = $me;
  //     toggleMenu(new_trigger, old_trigger);
  // }); 

  $mega_trigger.clickToggle(function() {   
    $me = $(this);
    console.log('AAAA');
    openMenu($me)  
  }, function() {
    $me = $(this);
    closeMenu($me)
    console.log('BBBB');
  });
  
  // $mega_menu_container.on('mouseenter mouseleave blur', function(e){
  //   var event = e.type;
  //   if(event == 'mouseleave' || event == 'blur'){
	// 	  window.clearTimeout(openTimer);
	// 	  openTimer = null;
	// 		closeMenu($me);
	// 		Lemonade.cache.old_trigger = false;
  //   } else {
  //     window.clearTimeout(intentTimer);
  //     intentTimer = null;
  //   } 
  // });
  
	$('#BtnMobileMenu').on('click keyup', function(e){
    if(e.type == 'click' || e.which == 13){
      var $me = $(this);
      if(!$nav_mobile.hasClass('ShowMenu')){
        $me.addClass('Open');
        $nav_mobile.addClass('ShowMenu');
        Lemonade.cache.$body.addClass('NoScroll');
        setTimeout(function(){
          $nav_mobile.focus();
        }, 300);
      } else {
        $me.removeClass('Open');
        closeMobileMenu();
        $('.SiteNavDropdownMobile').removeClass('ShowMenu');
        $('.HasDropdownMobile').removeClass('Open');
        setTimeout(function(){
          $nav_mobile.blur();
        }, 300);        
      }      
    }
  });  

	buildMegaMenus();

	headerOffsets(0, true);

	transitionPoint();

	winState();

	headerUtilities();

	Lemonade.cache.$win.on({
		scroll: function(){
			transitionPoint();
		},
		resize: function(){
			headerOffsets(0, false);
			winState();
		}
	});

};

// Billboards and Heros
Lemonade.billboards = function(){

	var $billboard_bg = $('.BillboardBGImg, .BillboardBGVideo');

	function billboard(el){
		Lemonade.headerCalculations();
		$me = el;
		win_height = Lemonade.cache.$win.height();
		billboard_height = win_height - (Lemonade.cache.header_specs.header_height + 200);
		$me.height(billboard_height);
	}

	billboard($billboard_bg);

	Lemonade.cache.$win.resize(function(){
    if(!Lemonade.cache.$body.hasClass('narrow-screen')){
      billboard($billboard_bg);
    }
	});

};

// Content accordions
Lemonade.accordion = function(){

  var $accTrigger = $('.AccTrigger'),
      $acc = $('.AccContent');

  // accordian content
  $accTrigger.on('click keyup', function(e){
    if(e.type == 'click' || e.which == 13){
      e.preventDefault();
      var $me = $(this),
          $content = $me.next('.AccContent');

      $acc.slideUp();
      if($me.hasClass('Open')){
        $me.removeClass('Open');
        return false;
      }
      $accTrigger.removeClass('Open');
      $me.addClass('Open');
      $content.slideToggle();
    }
  });

};

// Popup Newsletter
Lemonade.popup = function(){

  var $NP = $('#NewsletterPopup');
  $NP.find('a, input, .btn-subscribe').attr('tabindex', -1);

	function newsletterPopup(){
    $NP.addClass('Show');
    $NP.find('a, input, .btn-subscribe').attr('tabindex', 0);
	}

  if (typeof $.cookie('newsletter-modal') === 'undefined') {
    $.cookie('newsletter-modal', '1', { expires: 30, path: '/' });
    setTimeout(function(){
			newsletterPopup();
		}, 3000);
  }

  $('.newsletter-close').on('click keyup', function(e){
    if(e.type == 'click' || e.which == 13){
      $NP.removeClass('Show');
      $NP.find('a, input, .btn-subscribe').attr('tabindex', -1);
    }
  })

};

// Library dependancy https://github.com/kenwheeler/slick/
// Slick init
Lemonade.slick = function(){

	var $slick = $('.Slick'),
      $mobile_slick = $('.MobileSlick'),
      $slickCol = $('.SlickColl');

	$slick.on('init', function(){
		Lemonade.slickAlignArrows();
  });
  
	$slickCol.on('init', function(){
		$slickCol.each(function(i,el){
      setTimeout(function(){
        $(el).find('.slick-slide').removeAttr('aria-describedby');
      }, 500);
    });
	});  

	$slick.slick({
		lazyLoad: 'progressive'
  });
  
	$slickCol.slick({
		lazyLoad: 'progressive'
	});  

	$slick.on('lazyLoaded', function (e, slick, image, imageSource) {
		if(image.hasClass('ImgToBG')){
			image.parent().css('background-image', 'url("' + imageSource + '")').addClass('Show');
			image.hide();
		}
	});

	Lemonade.cache.$win.on({
		load: function(){
			if(Lemonade.cache.$body.hasClass('NarrowScreen')){
				$mobile_slick.slick({
					lazyLoad: 'progressive'
        });
			}
		},
		resize: function(){
			if(Lemonade.cache.$body.hasClass('MaxScreen') || Lemonade.cache.$body.hasClass('WideScreen')){
				if($mobile_slick.hasClass('slick-initialized')){
					$mobile_slick.slick('unslick');
				}
			} else {
				if(!$mobile_slick.hasClass('slick-initialized')){
					$mobile_slick.slick({
						lazyLoad: 'progressive'
          });
          Lemonade.matchHeight();
				}
			}
		}
	});

};

// Slick carousel vertically align prev/next arrows to carousel item image
Lemonade.slickAlignArrows = function(){

	setTimeout(function(){

		$('.SliderWrap').each(function(i, el){
			$me = $(el);
			if($me.hasClass('carousel')){
				img_height = $me.find('.slick-slide').first().find('img').first().height() / 2;
			  $me.find('.slick-arrow').css({'top': img_height});
			} else {
				$('.SlideArrow').addClass('init');
			}

		});
	}, 500);

};

Lemonade.autoResponsiveElements = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]'),
      $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="video-wrapper"></div>');
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

// Video embed sizing http://fitvidsjs.com/
Lemonade.fitVids = function(){
	Lemonade.cache.$body.find('.video-wrapper').fitVids();
};

// PDP thumb scroll
Lemonade.productMedia = function() {

	var instance = $('.ProductVideo').data('vide'),
			$product_thumbs = $('.ProductThumbs'),
			$product_slider = $('#ProductSlick'),
			$play_btn = $('.PlayBtn');

	$('.ProductThumb').on('click keyup', function(e){
    if(e.type == 'click' || e.which == 13){
      var $me = $(this),
          me_image,
          scroll_to;

      Lemonade.headerCalculations();

      if(!$me.hasClass('Active')){
        $me.addClass('Active').siblings('.ProductThumb').removeClass('Active');
        me_image = $me.attr('data-scroll-trigger');
        scroll_to = $('#'+me_image).offset().top;
        Lemonade.cache.$body.animate({scrollTop: scroll_to - Lemonade.cache.header_specs.total_offset});
        if(instance){
          vid = instance.getVideoObject();
          vid.pause();
          $('.PlayBtn')
            .find('.Pause')
            .hide()
            .end()
            .find('.Play')
            .show();
        }
      }
    }
	});

	$('.ProductVideo').on('click keyup', function(e){
    if(e.type == 'click' || e.which == 13){
      var $me = $(this).next('.PlayBtn');
      if(instance){
        vid = instance.getVideoObject();
        if (vid.paused) {
          $me
            .find('.Play')
            .hide()
            .end()
            .find('.Pause')
            .show();
          vid.play();
        } else {
          $me
            .find('.Pause')
            .hide()
            .end()
            .find('.Play')
            .show();
          vid.pause();
        }
      }
    }
	});
};

// PDP sticky sidebar
Lemonade.sticky = function(){

	Lemonade.cache.$win.on({
		load: function(){
			if(!Lemonade.cache.$body.hasClass('NarrowScreen')){
				stickyKit();
			}
		},
		resize: function(){
			if(Lemonade.cache.$body.hasClass('MaxScreen') || Lemonade.cache.$body.hasClass('WideScreen')){
				stickyKit();
			} else {
				detachStickyKit();
			}
		}

	});

	function detachStickyKit(){
		$("ProductDetails").trigger("sticky_kit:detach");
	}

	function stickyKit(){
		$("#ProductDetails").stick_in_parent({
			offset_top: 100,
			parent: '#ProductUpper'
		});
	}

}

// Back to top
Lemonade.backToTop = function(){

	if(Lemonade.cache.$back_to_top.length > 0){
		var grid_pos;

		function showBackToTop(){
			grid_pos = $('.GridWrapper').offset().top;
			if(Lemonade.windowScrollTop() > grid_pos){
				Lemonade.cache.$back_to_top.fadeIn();
			} else {
				Lemonade.cache.$back_to_top.fadeOut();
			}
		}

		Lemonade.cache.$back_to_top.on('click keyup', function(e){
      if(e.type == 'click' || e.which == 13){
        Lemonade.cache.$body.animate({'scrollTop': 0});
      }
		});

		Lemonade.cache.$win.scroll(function(){
			showBackToTop();
		});
	}

};

// Fancybox popups
Lemonade.popupModules = function(){
	$('.PopupTrigger').on('click keyup', function(e){
    if(e.type == 'click' || e.which == 13){
      var $me = $(this),
          me_data_popup = $me.data('popup'),
          $me_popup = '#'+me_data_popup;

      $.fancybox.open([{
        width: 600,
        height: 600,
        autoSize: true,
        href: $me_popup
      }], {
        padding: 30
      });
    }
  });
};

// Product grid hover photo
Lemonade.productHover = function(){

	var speed = 200;

	$('.ItemImage').on({
		mouseenter: function(){
			$me = $(this);
			$me_hover_img = $me.find('.HoverImg');

			if($me_hover_img.length > 0){
				$me_hover_img.stop().fadeIn(speed);
				$me.find('img').first().stop().fadeOut(speed);
			}
		},
		mouseleave: function(){
			$me = $(this);
			$me_hover_img = $me.find('.HoverImg');

			if($me_hover_img.length > 0){
				$me.find('.HoverImg').stop().fadeOut(speed);
				$me.find('img').first().stop().fadeIn(speed);
			}
		}
	});

};

// Mailchimp Ajax submit
Lemonade.mailchimp = function(){

  var status_message;
  
	function mailchimpSubmit(form_submit){

		var $me_submit = $(form_submit),
        $me_form = $me_submit.closest('form');

		$.ajax({
	    type: $me_form.attr('method'),
	    url: $me_form.attr('action'),
	    data: $me_form.serialize(),
	    cache       : false,
	    dataType    : 'json',
	    contentType: "application/json; charset=utf-8",
      error       : function(err) { alert("Could not connect to the registration server. Please try again later."); },
      success     : function(data) {
        if(data.result != "success") {
	        
		        status_message = 'Sorry try again later.';
	        
        } else {
	        
		        status_message = 'Thanks';
	        
        }
				$me_form.next('.SubscribeStatus').html(status_message).fadeIn(function(){
					setTimeout(function(){
						$me_form.next('.SubscribeStatus').fadeOut(function(){
							$(this).html('');
              $me_form.find('input[type="email"]').val('');
              $('.newsletter-close').click();
						});
					}, 3000);
				});
      }
	  });
	}

	$('#subscribe-footer').on('click keyup', function(e){
    if(e.type == 'click' || e.which == 13){
      e.preventDefault();
      mailchimpSubmit($(this));
    }
  });
  
	$('#subscribe').on('click keyup', function(e){
    if(e.type == 'click' || e.which == 13){
      e.preventDefault();
      mailchimpSubmit($(this));
    }
  });  
  
	$('#subscribe-countdown').on('click keyup', function(e){
    if(e.type == 'click' || e.which == 13){
      e.preventDefault();
      mailchimpSubmit($(this));
    }
	});  


};

// Product Zoom
Lemonade.productZoom = function(){

		var $takeover = $('#Takeover');

		$('.TakeoverImg').on('click keyup', function(e){
      if(e.type == 'click' || e.which == 13){
        var src = $(this).attr('src'),
            larger_src = src.replace('1024x1024', '2048x2048');

        $takeover.find('img').attr('src', larger_src);
        $takeover.fadeIn(function(){
          Lemonade.scrollNo();
        });
      }
		});

		$takeover.on('click keypress', function(e){
      if(e.type == 'click' || e.which == 13){
        $takeover.fadeOut(function(){
          $takeover.find('img').attr('src', '');
          Lemonade.scrollYes();
        });
      }
		});

};

// Product custom selects
Lemonade.customProductSelects = function(){

	var $selector_wrapper = $('.selector-wrapper'),
			variant_swatches = 'variants';

	// Loop through all variant options and construct custom UI
	$selector_wrapper.each(function(i,el){
		var $me = $(el),
				$me_select = $me.find('.single-option-selector'),
				$me_label = $me.find('label'),
				me_label_text = $me_label.text(),
				$me_options = $me.find('option'),
				$me_ul = $('<ul class="OptionSelect"></ul>'),
        $new_label = $('<div class="selection label">'+me_label_text+'</div>');

		if(me_label_text == 'Color' && variant_swatches == 'variants'){
			$me
				.addClass('color')
				.nextAll()
				.wrapAll('<div class="flex"></div>');
		}

		// build options in option select dropdown with data-attributes derived from real select
		$me_options.each(function(i, el){
			var $el = $(el),
					me_text = $el.text(),
					me_val = $el.val().replace(/["]/g, "&quot;"),
					me_handle = me_text.replace(/["]/g, "&quot;"),
					me_handle = me_handle.toLowerCase();

			if (me_val != 'Swatch'){
				$me_ul.append('<li class="' + me_handle.replace() + '" data-val="' + me_val + '"><span></span>' + me_text + '</li>');
			}
		});

		// Hide default select field + label
		$me_label.add($me_select).hide();

		// Add new selections to DOM
		if(me_label_text == 'Color'){
			$me
				.prepend($me_ul);
		} else {
			$me
				.prepend($me_ul)
				.prepend('<div class="OptionBox"><span class="OptionTitle">Select '+$me_label.text()+'</span><span class="icon icon-arrow"><svg><use xlink:href="#icon-down"></use></svg></span></div>');
		}

	});

};

Lemonade.customSelects = function(){
	var $selector_wrapper = $('.selector-wrapper, .fake-select'),
			variant_style = 'buttons';

	$('body').on('click keyup', '.selector-wrapper .OptionSelect li', function(e){
    if(e.type == 'click' || e.which == 13){
      e.stopPropagation();
      var $me = $(this),
          me_val = $me.data('val'),
          me_text = $me.text(),
          $me_selector_wrapper = $me.closest('.selector-wrapper');

      if(!$me.hasClass('Active')){
        $me
          .addClass('Active')
          .siblings('li')
          .removeClass('Active')
          .end()
          .closest('.selector-wrapper')
          .find('.single-option-selector')
          .val(me_val)
          .change();
      }

      if(!$me_selector_wrapper.hasClass('color')){
        if(variant_style == 'dropdown'){
          $me
            .closest('ul')
            .hide()
            .prev('.OptionBox')
            .removeClass('Active')
            .find('span')
            .not('.icon')
            .text(me_text);
        }
      }
    }
	});

	$selector_wrapper.on('click keypress', '.OptionBox', function(e){
    e.stopPropagation();
    if(e.type == 'click' || e.which == 13){
      var $me = $(this);
      if($me.hasClass('Active')){
        $me
          .removeClass('Active')
          .next('.OptionSelect')
          .hide();
      } else {
        $selector_wrapper.find('.OptionBox').removeClass('Active').next('.OptionSelect').hide();
        $me
          .addClass('Active')
          .next('.OptionSelect')
          .show();
      }
    }
	});
};

// Custom product quantity
Lemonade.productQuantity = function(){
  $(".Qty").find('span').on("click keyup", function(e){
    if(e.type == 'click' || e.which == 13){
      var $button = $(this);
      var oldValue = $('.Quantity').val();

      if ($button.hasClass('up')) {
        var newVal = parseFloat(oldValue) + 1;
      } else {
      // Don't allow decrementing below one
        if (oldValue > 0) {
          var newVal = parseFloat(oldValue) - 1;
        } else {
          newVal = 0;
        }
      }
      $('.Quantity').val(newVal);
    }
	});
};

// Product Page
Lemonade.productPage = function(options){
  var moneyFormat = options.money_format,
      variant = options.variant,
      translations = options.translations;

  // Selectors
  var $addToCart = $('#AddToCart'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice'),
			$quantityElements = $('.ProductQty'),
			$addToCartForm = $('#AddToCartForm'),
			$addToCartText = $('#AddToCartText'),
			$PreorderMessage = $('#PreorderMessage');

	function preorderCheck(){
		if($addToCartForm.hasClass('preorder')){
			$addToCart.addClass('preorder');
			$addToCartText.html('pre-order');
			$PreorderMessage.show();
		} else {
			$addToCartText.html(translations.soldOut);
		}
  }

  function aboutPanels(){
    $('.AboutTrigger').on('click keyup', function(e){
      if(e.type == 'click' || e.which == 13){
        var $me = $(this),
            me_panel = $me.attr('data-about');

        if(!$me.hasClass('Active')){
          $me.addClass('Active').siblings('.AboutTrigger').removeClass('Active');
          $(me_panel).show().siblings('.about-block').hide();
        }
      }
    });
  }

  if (variant) {
    // Select a valid variant if available
    if (variant.available) {
			// Available, enable the submit button, change text, show quantity elements
			$addToCart.removeClass('disabled').removeClass('preorder').prop('disabled', false);
      $addToCartText.html(translations.add_to_cart);
			$quantityElements.show();
			$PreorderMessage.hide();
    } else {
      // Sold out, check for preorder, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
			$quantityElements.hide();
			preorderCheck();
    }

    // Regardless of stock, update the product price
    $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
        .html(Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .show();
    } else {
      $comparePrice.hide();
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html(translations.unavailable);
		$quantityElements.hide();
		preorderCheck();
  }

  if( isMobile.iOS()){
    $('.ARTrigger-wrap').removeClass('is_desktop');
    function ARGateway(){
      var $AR_Inst = $('#ARInstr'),
          $AR_Slick = $('#ARSlick');

      $('#ARTrigger').on('click keyup', function(e){
        if(e.type == 'click' || e.which == 13){
          Lemonade.scrollNo();
          $AR_Inst.fadeIn(function(){
            $AR_Slick.slick();
            $('#ar-instr-inner').find('.SliderWrap').addClass('Show');
          });
        }
      });

      $('#ARInstrClose').on('click keyup', function(e){
        if(e.type == 'click' || e.which == 13){
          $AR_Inst.fadeOut(function(){
            Lemonade.scrollNo();
            $AR_Slick.slick('unslick');
            $('#ar-instr-inner').find('.SliderWrap').removeClass('Show');
          });
        }
      });
    }

    ARGateway();
    aboutPanels();
  } else {
    $('#ARInstr').remove();
  }

};

// Add to cart button states
Lemonade.addToCartflip = function($addToCartBtn){

  // Get label of add to cart button
	var addToCartText = "Purchase";

  // Make a copy of the add to cart button should we flip it
  $addToCartBtn
    .clone(true)
    .prop('disabled', false)
    .removeClass('disabled')
    .addClass('btn--unflipped')
    .find('span')
    .text(addToCartText)
    .end()
    .hide()
    .insertAfter($addToCartBtn);

  $addToCartBtn
    .unbind('click')
    .removeClass('disabled')
    .find('span')
    .text("View cart")
    .end()
    .bind('click', function(e) {
      e.preventDefault();
      window.location.href = '/cart';
    })
    .prop('disabled', false)
    .addClass('btn--flipped')
    .after('<div class="ContinueShopping"> <a class="btn--secondary" href="/collections/all">Continue shopping</a></div>');

  $('.ContinueShopping a').bind('click', Lemonade.backButton);

  // Unflip button if another variant is selected
  $('.single-option-selector, [name="quantity"]').bind('click', function() {
    $(this).closest('form').find('.btn--flipped, .ContinueShopping, .note').remove();
    $(this).closest('form').find('.btn--unflipped').removeClass('.btn--unflipped').show();
  });
};

if(document.querySelector('div[data-testid="GooglePay-button"]')) {
  setTimeout(function(){
    document.querySelector('div[data-testid="GooglePay-button"]').setAttribute('tabindex', -1)
    document.querySelector('div[data-testid="GooglePay-button"] svg').setAttribute('role', 'presentation');
    document.querySelector('div[data-testid="GooglePay-button"] svg').setAttribute('aria-hidden', 'true');
  }, 2000);
}

if (document.getElementById('challenge')) {
  setTimeout(function(){
    document.querySelector('.shopify-challenge__message').setAttribute('tabindex', -1);
    document.getElementById('g-recaptcha').focus();
  }, 1000);  
}

Lemonade.initCartFlyout = function(){
  var $addToCartBtn = $('#AddToCart');

  getCartJSON(renderCartFlyout, false);
  resizeCartFlyout();

  function getCartJSON(callback, show_flyout){
    $.getJSON('/cart.js', function(cart) {
      if (typeof callback !== undefined) {
				Lemonade.cache.$cartCount.text(cart.item_count);
        callback(cart, show_flyout);
      }
    })
  }

  function renderCartFlyout(cart, show_flyout){
    cart.item_count === 0 ? Lemonade.cache.$cart_flyout.addClass('empty') : Lemonade.cache.$cart_flyout.removeClass('empty');

    $('.CartCount').text(cart.item_count);

    // show cart flyout
    var source = $("#cart-template").html(),
        template = Handlebars.compile(source),
        items = [],
        img_small;

    $.each(cart.items, function(i,o){
      img_small = o.image ? o.image.replace(/^(.+)(\..+)$/, '$1_medium$2') : '';
      items.push({
        id: o.id,
        vendor: o.vendor,
        title: o.product_title,
        url: o.url,
        qty: o.quantity,
        price: Shopify.formatMoney(o.discounted_price),
        image: img_small,
				option1: o.variant_options[0],
				option2: o.variant_options[1],
				option3: o.variant_options[2],
        classes: (o.discounted_price) ? '' : 'free-item'
      });
    });

    $('.Summary span', '#CartFlyout').html( Shopify.formatMoney( cart.total_price ) );
    $('.Products', '#CartFlyout').html( template({items:items}) );

    if (show_flyout) {
      showCartFlyout();
    }
  }

  function showCartFlyout(){
    Lemonade.cache.$cart_flyout.addClass('Show');
    Lemonade.cache.$cart_flyout.attr('tabindex', 0);
    Lemonade.cache.$cart_flyout.find('a, input').attr('tabindex', 0);
    document.querySelector('div[data-testid="GooglePay-button"]').setAttribute('tabindex', 0)
  }

  function hideCartFlyout(){
    Lemonade.cache.$cart_flyout.removeClass('Show');
    Lemonade.cache.$cart_flyout.attr('tabindex', -1);
    Lemonade.cache.$cart_flyout.find('a, input').attr('tabindex', -1);
    document.querySelector('div[data-testid="GooglePay-button"]').setAttribute('tabindex', -1)
  }

  function addToCart(e){
    e.preventDefault();
    var $addToCartBtn = $(this),
        $addToCartForm = $(this).closest('form'),
				$addToCartBtnText = $(this).find('span');
		$('.note.errors').remove();
    if($addToCartForm.length) {
			$addToCartBtn
				.attr('data-add-to-cart', $addToCartBtnText.text())
				.prop('disabled', true)
				.addClass('disabled btn--loading');
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        type: 'post',
        data: $addToCartForm.serialize(),
        success: function(lineItem) {
					$addToCartBtn
						.removeClass('btn--loading')
						.prop('disabled', false)
						.removeClass('disabled btn--loading');
					getCartJSON(renderCartFlyout, true);
					Lemonade.addToCartflip($addToCartBtn);
				},
        error: function(XMLHttpRequest, textStatus) {
          var data = eval('(' + XMLHttpRequest.responseText + ')');
          var response = data.description;
          var status = XMLHttpRequest.status;
          $addToCartBtn.removeClass('btn--loading');
          if (status === 422 && $('#productSelect option').length === 1) {
            $addToCartBtnText.text("Sold Out");
          }
          else {
            $addToCartBtn.prop('disabled', false).removeClass('disabled');
            $addToCartBtnText.text($addToCartBtn.attr('data-add-to-cart'));
          }
          $addToCartBtn.after('<p class="note errors">' + response + '</p>');
        }
      });
    }
  
  };

  function updateQuantity(el){
    var $button = $(el),
        $qty = $button.parent().find('.Quantity'),
        oldQty = $qty.val(),
        variant_id = $qty.data('variant');

    if ($button.hasClass('up')) {
        var newQty = parseFloat(oldQty) + 1;
      } else {
      if (oldQty > 0) {
        var newQty = parseFloat(oldQty) - 1;
      } else {
        newQty = 0;
      }
    }

    $qty.attr('value', newQty);
    updateCart(variant_id, newQty);
  }

  function updateCart(variant_id, quantity){
    var params = {
      type: 'POST',
      url: '/cart/change.js',
      data:  'quantity='+quantity+'&id='+variant_id,
      dataType: 'json',
      success: function(cart) {
        renderCartFlyout(cart, true);
      },
      error: function(XMLHttpRequest, textStatus) {
        Shopify.onError(XMLHttpRequest, textStatus);
      }
    };

    $.ajax(params);
  }

  function resizeCartFlyout() {
    Lemonade.cache.$cart_flyout.find('.Products').css({
      height: (Lemonade.cache.$win.outerHeight() - ($('.Summary').outerHeight() + $('.flyout-header').height()))
    });
  }

  Lemonade.cache.$cart_flyout.on('click keyup', '.FlyoutQty span', function(e){
    if(e.type == 'click' || e.which == 13){
      updateQuantity(this);
    }
  });

  $addToCartBtn.on('click keyup', function(e){
    if(e.type == 'click' || e.which == 13){
      addToCart();
    }
  });

  Lemonade.cache.$win.on('resize', function(){
    resizeCartFlyout();
  });

  Lemonade.cache.$body.on('click keyup', function(e){
    var $target = $(e.target);
    if(e.type == 'click' || e.which == 13){
      if($target.attr('id') == 'CartTrigger'){
        if(!$target.hasClass('Active')){    
          $target.addClass('Active').attr('aria-expanded', 'true');
          Lemonade.cache.$cart_flyout.addClass('Show');
          Lemonade.cache.$cart_flyout.attr('tabindex', 0);
          Lemonade.cache.$cart_flyout.find('a, input').attr('tabindex', 0);
          if (document.querySelector('div[data-testid="GooglePay-button"]')) {
	          document.querySelector('div[data-testid="GooglePay-button"]').setAttribute('tabindex', 0)
          }
          setTimeout(function(){
            Lemonade.cache.$cart_flyout.focus();
          }, 300);            
        } else {
          $target.removeClass('Active').attr('aria-expanded', 'false');
          // Lemonade.cache.$cart_flyout.removeClass('Show');
          Lemonade.cache.$cart_flyout.attr('tabindex', -1);
          Lemonade.cache.$cart_flyout.find('a, input').attr('tabindex', -1);
          if (document.querySelector('div[data-testid="GooglePay-button"]')) {
	          document.querySelector('div[data-testid="GooglePay-button"]').setAttribute('tabindex', -1)
          }
          setTimeout(function(){
            Lemonade.cache.$cart_flyout.blur();
          }, 300); 
                  
        }
      } else if($target.hasClass('icon-close')){
        Lemonade.cache.$cart_flyout.removeClass('Show');
        Lemonade.cache.$cart_flyout.attr('tabindex', -1);
        Lemonade.cache.$cart_flyout.find('a, input').attr('tabindex', -1);
        document.querySelector('div[data-testid="GooglePay-button"]').setAttribute('tabindex', -1)
      } else {
        if(!$target.closest('#CartFlyout').length){
          Lemonade.cache.$cart_flyout.removeClass('Show');
          Lemonade.cache.$cart_flyout.attr('tabindex', -1);
          Lemonade.cache.$cart_flyout.find('a, input').attr('tabindex', -1);
          if(document.querySelector('div[data-testid="GooglePay-button"]')) {
            document.querySelector('div[data-testid="GooglePay-button"]').setAttribute('tabindex', -1)
          }
        }
      }
    }
    // e.stopPropagation();
    if (e.defaultPrevented) return;
  });

  return {
    renderCartFlyout: renderCartFlyout,
    showCartFlyout: showCartFlyout,
    hideCartFlyout: hideCartFlyout,
    addToCart: addToCart
  }
};

Lemonade.gdpr = function(){

  var $gdpr = $('#Gdpr');
  $gdpr.find('a, input').attr('tabindex', -1)

  if (typeof $.cookie('gdpr-modal') === 'undefined') {
		setTimeout(function(){
      $gdpr.addClass('show');
      $gdpr.find('a, input').attr('tabindex', 0)
		}, 1500);

		$('#GdprAgree').on('click keyup', function(e){
      if(e.type == 'click' || e.which == 13){
        var $me = $(this);
        if($me.is(':checked')){
          setTimeout(function(){
            $gdpr.removeClass('show');
            $gdpr.find('a, input').attr('tabindex', -1)
          }, 400);
          $.cookie('gdpr-modal', '1', { expires: 90, path: '/' });
        }
      }
		});
  }

};

Lemonade.collectionAjaxLoad = function(){

	var $load_more = $("#LoadMore"),
			load_more_text = $load_more.attr('data-button-text'),
			page_number = 1;

	// Load more products into the page via AJAX API
	function loadMoreProducts(me, page_number, path) {
		var wrap = me.closest('.btn-wrap').closest('.GridWrapper').find('.AjaxPager'),
				maxpage = me.data('maxpage'),
				the_query,
				url,
				json_path = 'json';

		if (!path) {
			path = location.pathname;
			the_query = location.search;

			if (the_query){
				url = path + the_query + '&page=' + page_number;
			} else {
				url = path + '?page=' + page_number;
			}
    }
   

		$.ajax({
			type: 'GET',
			dataType: 'html',
			url: url,
			data: the_query,
			success: function(data) {
				var $data = $(data),
						$new_posts = $data.find(".AjaxPager").html(),
						wrap_index;

				if ($data.length) {
          wrap_index = page_number - 2;
          
          // Find the last loaded product
          const lastProductLoaded = document.querySelector('.product-item:last-child'); 
          // const lastProductLoadedTitle = lastProductLoaded.querySelector('.product-vendor').innerHTML;
          // alert(`Last product is ${lastProductLoadedTitle}`);

          document.getElementById('LoadMore').blur();
          $(".AjaxPager").append($new_posts);
                  
          event.preventDefault()
          
          // Find the first new loaded product
          const newLoadedProduct = lastProductLoaded.nextElementSibling;
          newLoadedProduct.focus();
          // alert(`First new loaded product is ${newLoadedProduct}`);

          // LazyLoad
          $('[data-src]').each(function(){
            var $this = $(this),
                src = $(this).data('src');
            $this.attr('src', src);
            // console.log('Lazy Loading ' + src);
          });

					Lemonade.slickAlignArrows();
					if(!Lemonade.cache.$body.hasClass('collection-lifestyle') || Lemonade.cache.$body.hasClass('NarrowScreen')){
						$('.Slick, .SlickMobile').slick({
							lazyLoad: 'progressive'
						});
					}
					Lemonade.lazyLoad();
					me.attr("disabled", false);
					if (maxpage === page_number) {
						me.hide();
						$('.LoadMoreWrapper').hide();
					} else {
            me.attr("disabled", false);          
					}
				}
			},
			error: function(data) {
				return wrap.append('<div>Something Went Wrong</div>');
			}
		});
	}

	// Trigger AJAX Load more on collection page
	$load_more.click(function(e) {
		page_number++;
		loadMoreProducts($(this), page_number);
  });
  
  $load_more.on('keypress', function(e) {
    if(e.which == 13) {
      page_number++;
      loadMoreProducts($(this), page_number);
    };
	});

};

Lemonade.masonry = function(){

  var $masonry = $('.Masonry'),
      $masonry_artists = $('.MasonryArtists');

  $masonry.imagesLoaded().progress( function() {
    $masonry.masonry('layout');
    Lemonade.cache.$win.resize();
  });

  $masonry.masonry({
    // options
    itemSelector: '.MasonryItem',
    gutter: 50
  });

  $masonry_artists.imagesLoaded().progress( function() {
    $masonry_artists.masonry('layout');
  });

  $masonry_artists.masonry({
    // options
    itemSelector: '.MasonryItem',
    gutter: 5
  });

};

Lemonade.artistViewToggleInit = function () {

  function hideArtist(){
    $('.ArtistItemLink').removeClass('Active');
    $('.ImageContainer').removeClass('Show');
  }

  $('.ArtistItemLink').on({
    mouseenter: function(){
      var $me = $(this),
          me_index = $me.attr('data-artist-index');
      hideArtist();
      $me.addClass('Active');
      $('#'+me_index).addClass('Show');
      $('.Masonry').masonry('reloadItems');
      Lemonade.masonry();
    },
    focus: function(){
      var $me = $(this),
          me_index = $me.attr('data-artist-index');
      hideArtist();
      $me.addClass('Active');
      $('#'+me_index).addClass('Show');
      $('.Masonry').masonry('reloadItems');
      Lemonade.masonry();
    }
  });

};

Lemonade.artistPage = function(){

  var $an = $('.animate-name');

  function animateName(){
    var names = $an.find('span');
    var anim = {
      'opacity': 1,
      'queue': true,
      'easing': 'easeInQuint',
      'duration': 300
    };
    names.stop(true);

    for(var i = 0; i < names.length; i++){
      var mod = i % 3;
      switch(mod){
        case 0:
          $(names[i])
          .animate(anim)
          break;
        case 1:
          $(names[i])
          .delay(500)
          .animate(anim)
          break;
        case 2:
          $(names[i])
          .delay(1000)
          .animate(anim)
        default:
      }
    }

  }

  Lemonade.cache.$win.load(function(){
    setTimeout(function(){
      animateName();
    }, 300);
  });


};

Lemonade.mobileFilterSort = function(){

  var $mt = $('.MT');

  $('.MT').click(function(){
    var $me = $(this),
        me_data = $me.attr('data-sort-filter');

    if($me.hasClass('Active')){
      $me.removeClass('Active');
      $(me_data).hide();
    } else {
      $me.addClass('Active').siblings('.MT').removeClass('Active');
      $(me_data).show().siblings('.mobile-panel').hide();
    }

  });
};

Lemonade.artworkInquiry = function(){
  $('.product-prices').on('click', '#InquiryTrigger', function(){
    $(this).hide();
    $('.inquiry-form').show();
  });
};

Lemonade.blogFilters = function(){

  var $blog_wrapper = $('.BlogWrapper'),
      $filter_trigger = $('.FilterTrigger'),
      total_width = 0;

  $filter_trigger.click(function(){
    var $me = $(this),
        me_val = $me.attr('data-filter');

    if(!$me.hasClass('Active')){
      $me.addClass('Active').siblings('span').removeClass('Active');

	    if(me_val != 'show-all'){
        $blog_wrapper.find('.article').removeClass('Show');
        $blog_wrapper.find('.'+me_val).addClass('Show');
	    } else {
        $('.BlogWrapper').find('.article').addClass('Show');
        $showAll.addClass('active');
	    }

    } else {
      $me.removeClass('Active').siblings('span').removeClass('Active');
      $blog_wrapper.find('.'+me_val).removeClass('Show');
      $('span[data-filter="show-all"]').click();
    }
    setTimeout(function(){
      Lemonade.cache.$win.resize();
    }, 200);
    
  });

  function horzMenu(){
    $filter_trigger.each(function(i,el){
      var $me = $(el),
          me_width = $me.width() + 30;
      total_width = total_width + me_width;
    });

    $('.FilterList').width(total_width);

  }

  Lemonade.cache.$win.on({
    load: function(){
      horzMenu();
    },
    resize: function(){
      //horzMenu();
    }
  })
};

Lemonade.viewInRoomApp = {


	init: function() {
    this.setup();
    this.corners();
		this.sections = [
			'upload-photo-app--step-1',
			'upload-photo-app--step-2',
		];
	},

	previewFile: function(evt) {

		var previewImg = document.getElementById('preview-img-position');
		var file = evt.currentTarget.files[0];
		var reader = new FileReader();

		reader.addEventListener("load", function() {
			previewImg.src = reader.result;

			this.activateSection(1);
		}.bind(this), false);

		if (file) {
			reader.readAsDataURL(file);
		}

	},

	closeApp: function() {
		this.sections.forEach(function(section) {
			$('html').removeClass(section);
		});
		$('html').removeClass(this.appClass);
	},

	setup: function() {

		$img = $("#okay");
		$input = $('#upload-photo-dropzone-input');

		$input.on('change', this.previewFile.bind(this));

		$('#upload-photo-dropzone').on('click', function() {
			$input.click();
		})

		$img.draggable();
	},

	activateSection: function(stepIndex) {
    $("html, body").scrollTop(0);
		this.appClass = 'is-upload-photo-app-active';

		this.sections.forEach(function(section) {
			$('html').removeClass(section);
		});

		$('html').addClass(this.sections[stepIndex]);
		$('html').addClass(this.appClass);
  },
  
  corners: function(){
    $('.product-inner-div').resizable({
      handles: {
        'ne': '#negrip',
        'se': '#segrip',
        'sw': '#swgrip',
        'nw': '#nwgrip',
      }
    }); 
  }
}

Lemonade.countDown = function() {  
	$("#countdown-timer")
			.countdown(liquidVars.countdownDate, function (event) {
        $(this).html(event.strftime(''
            + '<span class="countdown-timer-item">%w</span>'
            + '<span class="countdown-timer-item">:</span>'
						+ '<span class="countdown-timer-item">%d</span>'
						+ '<span class="countdown-timer-item">:</span>'
						+ '<span class="countdown-timer-item">%H</span>'
						+ '<span class="countdown-timer-item">:</span>'
						+ '<span class="countdown-timer-item">%M</span>'
						+ '<span class="countdown-timer-item">:</span>'
						+ '<span class="countdown-timer-item">%S</span>'));
			});
}

Lemonade.galleryPage = function(){
  function resizeMap(){
    $('.gallery-info iframe').css('height', $('.info-wrapper .about-image').outerHeight());
  }
  
  Lemonade.cache.$win.on('load resize', resizeMap);
}

// Initialize Lemonade JS on docready
$(Lemonade.init);